module.exports = __webpack_public_path__ + "static/media/27.8a000fe4.png";